import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

/**********************
 * Login / Register (inline, minimal)
 *********************/
function LoginPage() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await login(email, password);
      nav("/");
    } catch (ex) {
      setErr(ex.message);
    }
  };
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Sign in</h1>
      <form
        className="jh-form-grid"
        onSubmit={submit}
        style={{ maxWidth: 420, margin: "0 auto" }}
      >
        {err && (
          <div className="jh-note" style={{ color: "#b91c1c" }}>
            {err}
          </div>
        )}
        <div className="jh-field">
          <label className="jh-label">Username / Email</label>
          <input
            className="jh-input wide"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="jh-field">
          <label className="jh-label">Password</label>
          <input
            type="password"
            className="jh-input wide"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="jh-actions">
          <button className="jh-btn" type="submit">
            Sign in
          </button>
        </div>
        <div className="jh-note">
          No account? <Link to="/register">Create one</Link>
        </div>
      </form>
    </section>
  );
}

export default LoginPage;
